let GeoLocation = (function() {
    let DISTANCE = 50;
    let closestStore = function(){
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position) {
              var pos = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              };
  
              __getStoreData(pos, 10);
            }, function() {
              
            });
          } else {
            // Browser doesn't support Geolocation
          }
    };

    /*
        Find closest store to the user. Default search distance is hardcoded to 10, if nothing is found within 10 miles
        it will search distance + 10 until it finds a store.
    */
    let __getStoreData = function(pos, distance){
        fetch(window.location.origin + 
            `/wp-json/monro/v1/stores/coords?useBrand=true&brandId=${Util.getCookie('brand_id')}&latitude=${pos.lat}&longitude=${pos.lng}&distance=${distance}`)
            .then((resp) => resp.json())
                .then(function(stores) {
                    if(stores.data.length > 0){
                        Util.setCookie('store_location',stores.data[0].Id, 180);
                        window.location.reload();
                    } else if(distance < GeoLocation.DISTANCE) {
                        __getStoreData(pos, distance + 10);
                    }
                }
            );       
    }
    return {
        closestStore: closestStore
    };
  })();